import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
const ProductIdentifier = (props) => {
  const {
    value = "123.456.78",
    className,
    prefix = "",
    label,
    subtle,
    ...other
  } = props;
  const classes = cx(
    `${prefix}product-identifier`,
    className,
    subtle && `${prefix}product-identifier--subtle`
  );
  return /* @__PURE__ */ jsxs("span", { className: classes, ...other, children: [
    label && /* @__PURE__ */ jsx("span", { className: `${prefix}product-identifier__label`, children: label }),
    /* @__PURE__ */ jsx("span", { className: `${prefix}product-identifier__value`, children: value })
  ] });
};
var ProductIdentifier_default = ProductIdentifier;
export {
  ProductIdentifier_default as default
};
